import {LookupService} from "../common/api.service";

export const getUserToken = function () {
    const expirationTime = localStorage.getItem('expirationTime') ?? null;
    if (expirationTime == null || Date.now() > expirationTime) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            return null;
        }
    return localStorage.getItem('token') ? localStorage.getItem('token') : null
}
export const setUserToken = function (token) {
    localStorage.setItem('token', token);
}
export const setExpirationTime = function (expirationTime) {
    localStorage.setItem('expirationTime',expirationTime)
}

export const getUser = function () {
    return localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
}
export const getUserRole = function () {
    const user= localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
    return user?.data?.userRoles?.roleName;
}

export const setUser = function (data) {
    localStorage.setItem('user', JSON.stringify(data));
}
export const getGraduateTypes = async function () {
    const res = await LookupService.getGraduateTypes();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching Graduate Types");
    }

};
export const getTrainingCenters = async function () {
    const res = await LookupService.getTrainingCenters();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching CPD providers");
    }

};

export const getHealthProfessions = async function () {
    const res = await LookupService.getHealthProffesions();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching Health Professions");
    }

};

export const getCourses = async function () {
    const res = await LookupService.getCourses();
    if (res.data.status === 200) {
        return res.data.data
    } else {
        alert("Error while fetching course list");
    }

};
export const getProgramTypes = async function () {
    const res = await LookupService.getProgramTypes();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching program types");
    }

};
export const getCourseLevel = async function () {
    const res = await LookupService.getCourseLevel();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching course level");
    }

};
export const getTrainerTypes = async function () {
    const res = await LookupService.getTrainerTypes();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching trainer types");
    }

};
export const getPrograms = async function () {
    const res = await LookupService.getPrograms();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching programs");
    }

};
export const getProgramsDrp = async function (id) {
    const res = await LookupService.getProgramsDrp(id);
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching programs");
    }

};
export const getTrainers = async function () {
    const res = await LookupService.getTrainers();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching trainers");
    }

};
export const getTrainees = async function () {
    const res = await LookupService.getTrainees();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching trainees");
    }

};
export const getProfessions = async function () {
    const res = await LookupService.getProfession();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching profession");
    }

};
export const getEducationalLevel = async function () {
    const res = await LookupService.getEducationalLevel();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching educational levels");
    }

};
export const getCategories = async function () {
    const res = await LookupService.getCategories();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching categories");
    }

};
export const getRegionList = async function () {
    const res = await LookupService.getRegion();
    if (res.status === 200) {
        return res.data;
    } else {
        alert("Error while fetching regions");
    }
};
export const getTrainerSelectionCriteriaList = async function () {
    const res = await LookupService.getTrainerSelectionCriteria();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching Trainer Selection Criteria");
    }

};
export const getWorkExperienceList = async function () {
    const res = await LookupService.getWorkExperience();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching Work Experience");
    }

};
export const getTrainingCategories = async function () {
    const res = await LookupService.getTrainingCategories();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching Work Training Categories");
    }
};
export const getLevelOfStudies = async function () {
    const res = await LookupService.getLevelOfStudies();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching Level of Studies");
    }
};
export const getAccreditedBy = async function () {
    const res = await LookupService.getAccreditedBy();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching Accredited by");
    }
};
export const getCourseOwners = async function () {
    const res = await LookupService.getCourseOwners();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching Course Owners");
    }
};
export const getAudiences = async function () {
    const res = await LookupService.getAudiences();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching Target Audiences");
    }
};
export const getTrainingCourseUsed = async function () {
    const res = await LookupService.getTrainingCourseUsed();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching Training Course Used");
    }
};
export const getFoundedBy = async function () {
    const res = await LookupService.getFoundedBy();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching Founded By");
    }
};
export const getActivityDeliveries = async function () {
    const res = await LookupService.getActivityDeliveries();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching Founded By");
    }
};
export const getCpdProviders = async function () {
    const res = await LookupService.getCpdProviders();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching CPD providers");
    }
};
export const getZoneByRegionId = async function (regionId) {
    const res = await LookupService.getZoneByRegionId(regionId);
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching zones");
    }
};
export const getZoneList = async function () {
    const res = await LookupService.getZones();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching zones");
    }
};
export const getWoredaByZoneId = async function (zoneId) {
    const res = await LookupService.getWoredaByZoneId(zoneId);
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching zones");
    }
};
export const getFacilitiesByWoredaId = async function (woredaId) {
    const res = await LookupService.getFacilityByWoredaId(woredaId);
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching facilities");
    }
}
export const getWoredaList = async function () {
    const res = await LookupService.getWoredas();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching woredas");
    }
};
export const getExpertLevels = async function () {
    const res = await LookupService.getExpertLevels();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching expert levels");
    }
};
export const getFacilityTypes = async function () {
    const res = await LookupService.getFacilityTypes();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching facility types");
    }
};
export const getUserFacilities = async function (locationId, facilityTypeId) {
    const res = await LookupService.getUserFacilities(locationId, facilityTypeId);
    if (res.status === 200) {
        return res.data?.data
    } else {
        alert("Error while fetching Facilities");
    }
};
export const getAccredatorOwnership = async function () {
    const res = await LookupService.getAccredatorOwnership();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching accreditor ownerships");
    }
};
export const getTraineeFacilities = async function () {
    const res = await LookupService.getTraineeFacilities();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching new trainee Facilities.");
    }
};
export const getUniversityOwnership = async function () {
    const res = await LookupService.getUniversityOwnership();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching university ownerships");
    }
};
export const getGenerationLevels = async function () {
    const res = await LookupService.getGenerationLevels();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching generation levels");
    }
};

export const getUniversities = async function () {
    const res = await LookupService.getUniversities();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching universities");
    }
};

export const getCertReason = async function () {
    const res = await LookupService.getCertReasons();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching certificate reasons");
    }
};

export const getStudentStatuses = async function () {
    const res = await LookupService.getStudentStatuses();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching student statuses");
    }
};

export const getEducationalPrograms = async function () {
    const res = await LookupService.getEducationalPrograms();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching educational programs");
    }
};

export const getDisciplines = async function () {
    const res = await LookupService.getDisciplines();
    if (res.status === 200) {
        return res.data
    } else {
        alert("Error while fetching disciplines");
    }
};
